


































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { DataTableHeader } from 'vuetify';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { JobExecution, JobExecutionResource } from '@/api/jobexecutions/';

@Component({
  computed: mapState(['fiId']),
})
export default class JobExecutionsTable extends Vue {
    fiId!: string;

    headers: DataTableHeader[] = [
      { text: 'ID', value: 'id' },
      { text: 'Core Processing Date', value: 'coreProcessingDate' },
      { text: 'Job Type', value: 'jobType' },
      { text: 'Status', value: 'jobExecutionStatus' },
      { text: 'Failure Reason', value: 'failureDescription' },
      { text: 'Start Time', value: 'startTime' },
      { text: 'End Time', value: 'endTime' },
    ];

    footerProps: any = {
      'items-per-page-options': [{ value: -1, text: 'All' }, 15, 30, 60],
    };

    loading: boolean = false;

    jobExecutionResults: JobExecution[] = [];

    totalItems: number = 0;

    dataTablePagingOptions = {};

    @Inject('JobExecutionResource')
    jobExecutionResource!: JobExecutionResource;

    @Watch('dataTablePagingOptions')
    updateDataTable() {
      this.getJobExecutions();
    }

    @Watch('fiId')
    onFiChange() {
      this.jobExecutionResults = [];
      this.getJobExecutions();
    }

    showErrorMessage(error: string) {
      const al = new Alert(error, NoticeClass.ERROR);
      al.setTimeout(5000);
      this.$store.dispatch('notices/add', al);
    }

    mounted() {
      this.getJobExecutions();
    }

    getJobExecutions() {
      this.loading = true;

      this.jobExecutionResource.getJobExecutions(this.fiId, this.dataTablePagingOptions)
        .then((result: any) => {
          this.jobExecutionResults = result.rows;
          this.totalItems = result.size;
        }).catch((error: any) => {
          this.handleError(error);
        }).finally(() => {
          this.loading = false;
        });
    }

    handleError(error: any) {
      if (error.response.status !== 401) {
        if (error.response.status === 504) {
          this.showErrorMessage('The request timed out.');
        } else {
          this.showErrorMessage('An unexpected error occurred while attempting to perform the request.');
        }
      }
    }

    formatDateTime = (date: Date) => {
      if (date !== null) {
        const dateFormatOptions = {
          hour: 'numeric',
          minute: 'numeric',
          second: 'numeric',
        };
        return new Date(date).toLocaleDateString('en-US', dateFormatOptions).replace(',', '');
      }
      return '';
    }

    formatFailureType = (type: string) => (type === null ? '' : type.replace(/_/g, ' '))
}
